<template>
  <v-dialog v-model="show" max-width="500">
    <template #activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs"></slot>
    </template>
    <v-card>
      <v-card-title>Vrátit storno poplatek</v-card-title>
      <v-form @submit.prevent="processRefund()">
        <v-card-text>
          <div v-if="loading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Načítání...</p>
          </div>

          <v-alert v-else-if="!eligibility.eligible" type="warning" dense>
            {{ eligibility.reason || 'Storno poplatek nelze vrátit.' }}
          </v-alert>

          <template v-else>
            <v-alert type="info" dense class="mb-4">
              <strong>Storno poplatek k vrácení:</strong> {{ eligibility.feeAmount }} Kč
            </v-alert>

            <v-textarea
              v-model="reason"
              label="Důvod vrácení (volitelné)"
              outlined
              dense
              rows="2"
              hide-details="auto"
            ></v-textarea>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined small color="primary" @click="close()">Zrušit</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="eligibility.eligible"
            small
            color="error"
            type="submit"
            :loading="processing"
          >
            Vrátit {{ eligibility.feeAmount }} Kč
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RefundCancellationFeeDialog",
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      processing: false,
      reason: '',
      eligibility: {
        eligible: false,
        feeAmount: 0,
        alreadyRefunded: false,
        reason: null
      }
    }
  },
  methods: {
    async loadEligibility() {
      this.loading = true
      try {
        const { data } = await this.axios.get(
          `/v1/cleaning-orders/${this.orderId}/cancellation-fee-refund-eligibility`
        )
        this.eligibility = {
          eligible: !!data.eligible,
          feeAmount: data.feeAmount || 0,
          alreadyRefunded: !!data.alreadyRefunded,
          reason: data.reason || null
        }
      } catch (error) {
        console.error('Failed to load cancellation-fee refund eligibility:', error)
        this.eligibility = {
          eligible: false,
          feeAmount: 0,
          alreadyRefunded: false,
          reason: 'Nepodařilo se načíst informace o storno poplatku'
        }
      } finally {
        this.loading = false
      }
    },
    async processRefund() {
      if (!this.eligibility.eligible) return
      this.processing = true
      try {
        const { data } = await this.axios.post(
          `/v1/cleaning-orders/${this.orderId}/refund-cancellation-fee`,
          { reason: this.reason || undefined }
        )
        this.$store.commit('addAlert', {
          type: 'success',
          message: `Vrácen storno poplatek ${data.amount} Kč`
        })
        this.$emit('refunded', data)
        this.close()
      } catch (error) {
        console.error('Failed to refund cancellation fee:', error)
        const message = error.response?.data?.message || 'Nepodařilo se vrátit storno poplatek'
        this.$store.commit('addAlert', { type: 'error', message })
      } finally {
        this.processing = false
      }
    },
    close() {
      this.show = false
    },
    reset() {
      this.reason = ''
      this.eligibility = {
        eligible: false,
        feeAmount: 0,
        alreadyRefunded: false,
        reason: null
      }
    }
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.reset()
        this.loadEligibility()
      }
    }
  }
}
</script>

<style scoped>
</style>
